import { Link } from '@remix-run/react';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

export interface BreadcrumbItem {
	to: string;
	labelKey: string;
	values?: Record<string, string | number>;
}

interface BreadcrumbProps {
	breadcrumbs: BreadcrumbItem[];
}

export function Breadcrumb({ breadcrumbs }: BreadcrumbProps) {
	const { t } = useTranslation();

	return (
		<nav className="mt-8 flex items-center" aria-label="Breadcrumb">
			{breadcrumbs.map((item, index) => (
				<div key={item.to} className="flex items-center">
					{index > 0 && (
						<ChevronRightIcon
							className="mx-4 h-4 w-4 flex-shrink-0 text-gray-400"
							aria-hidden="true"
						/>
					)}
					<Link
						to={item.to}
						className="text-sm font-medium text-gray-500 underline-offset-2 hover:text-neutral-900 hover:underline"
					>
						{t(item.labelKey, item.values)}
					</Link>
				</div>
			))}
		</nav>
	);
}
